import { METHOD, request } from "./../../utils/request";
import { EducationalPeriods } from "./../api";

async function getAll(params) {
  return request(EducationalPeriods.getAll, METHOD.GET, params);
}
async function getDetails(params) {
  return request(EducationalPeriods.getDetails, METHOD.GET, params);
}
async function getDialog(params) {
  return request(EducationalPeriods.getDialog, METHOD.GET, params);
}

async function add(data) {
  return request(EducationalPeriods.add, METHOD.POST, data);
}
async function update(data) {
  return request(EducationalPeriods.update, METHOD.POST, data);
}

async function changeActivationType(data) {
  return request(EducationalPeriods.changeActivationType, METHOD.POST, data);
}

async function finalDelete(data) {
  return request(EducationalPeriods.finalDelete, METHOD.POST, data);
}
async function deleteImage(data) {
  return request(EducationalPeriods.deleteImage, METHOD.POST, data);
}

export default {
  getAll,
  getDetails,
  getDialog,
  add,
  update,
  changeActivationType,
  finalDelete,
  deleteImage,
};
